<template>
  <view class="pft-data-item-container" :style="style" :flex="flex">
    <template v-if="componentLoading">
      <Loading />
    </template>
    <template v-else>
      <template v-for="(keyItem, index) of keys">
        <view v-if="dataVal && (dataVal[keyItem.name] || keyItem.tpl)" v-bind:key="`a${index}`" class="item-val" :style="keyItem.style">
          <component v-if="keyItem.tpl" :is="renderTpl(keyItem.tpl, dataVal)"></component>
          <text class="text" v-else>{{ dataVal[keyItem.name] }}</text>
        </view>
        <view v-else class="item-val" v-bind:key="`b${index}`" :style="keyItem.style"> 无数据 </view>
      </template>
    </template>
  </view>
</template>
<script lang="tsx" setup>
import { ref } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import { JSX } from "vue/jsx-runtime"
defineOptions({
  name: "DataItem",
})
interface DataTextProps {
  keys: { name: string; style: { [key: string]: string }; tpl?: string }[]
  flex?: string
  style?: { [key: string]: string }
}

withDefaults(defineProps<DataTextProps>(), {
  keys: () => [],
  flex: () => "dir:left main:justify cross:stretch",
  style: () => ({}),
})

/**
 * 模板函数，识别模板中{key%|class}格式的字符串，替换为对应的view元素并带上相应的class
 * @param tpl
 * @param key
 * @param val
 */

const renderTpl = (tpl: string, data: { [key: string]: string }) => {
  /**
   * 声明特征识别的正则，可识别一下格式的字符串
   * {[key]%|class}
   * {[key]|class1}
   * {[key]}
   */
  const reg = /(\{[^{}]+\})/
  const match = tpl.match(reg)
  if (!match) {
    return tpl
  } else {
    const jsxObj: { [key: string]: JSX.IntrinsicElements } = {}
    const jsxArr: JSX.IntrinsicElements[] = []
    for (let i of match) {
      const keyTpl = i.slice(1, -1).split("|")[0] //可能是[key]%或者[key]
      const classStr = i.slice(1, -1).split("|")[1]
      const classes = (classStr ? classStr.split(" ") : []).join(" ")
      //正则识别keyTpl中的key
      const resultMatch = keyTpl.match(/\[([^{}]+)\]/)
      if (resultMatch) {
        const key = resultMatch[1]
        const tplStr = keyTpl.replace(`[${key}]`, data[key])
        {
          jsxObj[i] = <text class={classes}>{tplStr}</text>
        }
      }
    }
    const newAr = tpl.split(reg)
    for (let i of newAr) {
      if (jsxObj[i]) {
        jsxArr.push(jsxObj[i])
      } else {
        jsxArr.push(<text>{i}</text>)
      }
    }
    return <view>{[...jsxArr]}</view>
  }
}

const componentLoading = ref<boolean>(true)

const dataVal = ref<{ [key: string]: string }>({})

const loading = () => {
  componentLoading.value = true
}

const setData = (val: { [key: string]: string }) => {
  componentLoading.value = false
  dataVal.value = val
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-data-item-container {
  box-sizing: border-box;
  width: 100%;
  padding: 13px 12px;
  .item-val {
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 14px;
    color: rgba(230, 247, 255, 0.75);
    line-height: 20px;
  }
}
</style>
